__turbopack_context__.v({
  "card": "programhiglights-module-scss-module__7IxXEG__card",
  "cardBody": "programhiglights-module-scss-module__7IxXEG__cardBody",
  "cardImage": "programhiglights-module-scss-module__7IxXEG__cardImage",
  "carouselSection": "programhiglights-module-scss-module__7IxXEG__carouselSection",
  "contentWrapper": "programhiglights-module-scss-module__7IxXEG__contentWrapper",
  "inView": "programhiglights-module-scss-module__7IxXEG__inView",
  "logoContainer": "programhiglights-module-scss-module__7IxXEG__logoContainer",
  "section": "programhiglights-module-scss-module__7IxXEG__section",
  "textSection": "programhiglights-module-scss-module__7IxXEG__textSection",
});
